var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',[_vm._v("(с) "+_vm._s(new Date().getFullYear())+" Все права защищены (v1.001)")])])}
var staticRenderFns = []

export { render, staticRenderFns }